// ABOUTME: List component for tooltip content with customizable icons
// ABOUTME: Displays items as bullet points with optional custom icons

import { memo, type ReactNode } from "react"
import { CheckIcon } from "@shared/icons"

interface TooltipListProps {
  items: string[]
  icon?: ReactNode
  iconColor?: string
  className?: string
}

const DefaultBullet = memo(({ color }: { color: string }) => (
  <span className={`inline-block w-1.5 h-1.5 rounded-full ${color} mr-2 mt-1.5 flex-shrink-0`} />
))

DefaultBullet.displayName = "DefaultBullet"

export const TooltipList = memo(({ items, icon, iconColor = "bg-gray-400", className = "" }: TooltipListProps) => {
  if (!items.length) return null

  return (
    <ul className={`space-y-1 ${className}`}>
      {items.map((item, index) => (
        <li
          key={index}
          className="flex items-start text-[12px] leading-[16px]"
        >
          {icon ? <span className="mr-2 mt-0.5 flex-shrink-0">{icon}</span> : <DefaultBullet color={iconColor} />}
          <span className="whitespace-normal">{item}</span>
        </li>
      ))}
    </ul>
  )
})

TooltipList.displayName = "TooltipList"

// Pre-configured list with check icons
export const TooltipCheckList = memo(({ items, className = "" }: Omit<TooltipListProps, "icon" | "iconColor">) => (
  <TooltipList
    items={items}
    icon={<CheckIcon className="w-3 h-3 text-green-400" />}
    className={className}
  />
))

TooltipCheckList.displayName = "TooltipCheckList"
